<template>
  <div class="pm-page">
    <b-tabs card lazy v-model="activeTab">
      <b-tab title="SHOW PRODUCTS">
        <keep-alive>
          <ProductManagerList />
        </keep-alive>
      </b-tab>

      <b-tab title="EDIT PRODUCTS">
        <keep-alive><EditableProductsList /></keep-alive>
      </b-tab>

      <b-tab title="ADD PRODUCT">
        <keep-alive><AddProducts /></keep-alive>
      </b-tab>

      <b-tab title="ADD PRODUCT GROUP">
        <keep-alive><AddGroup /></keep-alive>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import ProductManagerList from "@/components/Products/ProductManagerList";
import EditableProductsList from "@/components/Products/EditProductList";
import AddProducts from "@/components/Products/AddProducts";
import AddGroup from "@/components/Products/AddGroup";

export default {
  name: "ProductManagerPage",
  components: { ProductManagerList, EditableProductsList, AddProducts, AddGroup },
  data() { return { activeTab: 0 }; }
};
</script>

<style scoped>
.pm-page { padding: 8px; }
.pm-page >>> .nav-tabs {
  border-bottom: 2px solid #E5E1DA;
  gap: 4px;
}
.pm-page >>> .nav-tabs .nav-link {
  border: 1.5px solid #E5E1DA;
  border-bottom: none;
  border-radius: 10px 10px 0 0;
  font-weight: 700;
  font-size: 13.5px;
  color: #736C63;
  padding: 10px 20px;
  background: #F7F5F2;
}
.pm-page >>> .nav-tabs .nav-link.active {
  background: #221F1C;
  color: #FFB06B;
  border-color: #221F1C;
}
</style>


// WEBPACK FOOTER //
// src/components/Products/ProductManagerPage.vue